import { Outlet } from "react-router-dom";

export const AuthLayout = () => {
  return (
    <div className="auth-layout">
      <div className="auth-card">
        {/* <div className="auth-header">
          <h1>Looksty</h1>
          <p>Находи идеи и записывайся к мастерам</p>
        </div> */}

        <Outlet />
      </div>
    </div>
  );
};
